import { ru } from 'date-fns/locale';
import { addDays, differenceInHours, format, formatDuration, isPast, parse, parseISO } from 'date-fns';
import type { Day } from 'library/models/events';
import normalizeTimetable from './normalizeTimetable';
import type { TimeTable } from '@src/library/types/events';

export const getDate = (date: any): string => {
	return format(new Date(date), 'd MMMM yyyy', { locale: ru });
};

export const getDateStrict = (date: any): string => {
	return format(new Date(date), 'd MMMM', { locale: ru });
};

export const getShortDate = (date: any): string => {
	const parsedDate = parse(date, 'dd.MM.yyyy', new Date());
	return format(parsedDate, 'dd.MM.yy', { locale: ru });
};
export const getShort = (date: any): string => {
	return format(new Date(date), 'dd.MM.yyyy', { locale: ru });
};

export const checkDate = (date: any): boolean => {
	return isPast(parseISO(date));
};

export const checkEventEnd = (date: any): boolean => {
	return isPast(addDays(parseISO(date), 1));
};

export const getTime = (date: any): string => {
	return format(new Date(date), 'HH:mm', { locale: ru });
};

export const getDuration = (table: Day[]) => {
	const normalDate = normalizeTimetable(table);
	let hours = 0;
	normalDate.forEach((item) => {
		hours += differenceInHours(item.time_to, item.time_from);
	});
	const days: number = Math.floor(hours / 24);
	hours = hours % 24;
	return hours
		? formatDuration({ days: days, hours: hours }, { format: ['days', 'hours'], locale: ru })
		: 'Менее 1 часа';
};

export const getEventDaysHours = (timetable: TimeTable[]) => {
	const uniqueDates = new Set();
	let totalHours = 0;

	timetable?.forEach(item => {
		uniqueDates.add(item.date);

		const timeFrom = parse(item.time_from, 'HH:mm', new Date());
		const timeTo = parse(item.time_to, 'HH:mm', new Date());

		totalHours += differenceInHours(timeTo, timeFrom);
	});

	return [uniqueDates.size, totalHours];
}
